import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import dismissRfqUpdates from "@insite/client-framework/Store/Context/Handlers/DismissRfqUpdates";
import { getAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link from "@insite/mobius/Link";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    siteName: state.context.website.name,
    session: getSession(state),
    myAccountPageUrl: getPageLinkByPageType(state, "MyAccountPage")?.url,
});

const mapDispatchToProps = {
    dismissRfqUpdates,
};

type Props = PageProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasToasterContext &
    HasHistory;

export interface HeaderStyles {
    page?: MobiusPageProps;
    container?: InjectableCss;
    skipToContent?: SkipNavStyles;
    websiteName?: InjectableCss;
    ScrollFixed?: InjectableCss;
    Scroll?: InjectableCss;
}

export const headerStyles: HeaderStyles = {
    page: {
        fullWidth: [true, true, true, true, true],
        css: css`
            .secondaryNavigation {
                background-color: rgb(255, 255, 255);
                > div[class^="Wrapper"] {
                    > div[class^="Navigation"] {
                        background-color: rgb(255, 255, 255);
                    }
                    > div {
                        background-color: rgb(255, 255, 255);
                    }
                }
            }
            position: fixed !important;
            z-index: 999;
            top: 0;
        `,
    },
    container: {
        css: css`
            background-color: rgb(168, 16, 16);
            display: flex;
            margin: 0px auto;
            padding: 0px 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            position: relative;
                        `,
                        css`
                            position: relative;
                        `,
                        css`
                            position: relative;
                        `,
                    ],
                    "max",
                )}
            .mainNavigation {
                width: 50%;
                [class^="GridItemStyle"]:last-child {
                    margin-top: 2px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    position: absolute;
                                    top: calc(40% - 0px);
                                    transform: translateY(-50%);
                                    left: 64px;
                                    margin-top: 0px;
                                `,
                                css`
                                    position: absolute;
                                    top: calc(40% - 0px);
                                    transform: translateY(-50%);
                                    left: 64px;
                                    margin-top: 0px;
                                `,
                                css`
                                    position: absolute;
                                    top: calc(40% - 0px);
                                    transform: translateY(-50%);
                                    left: 64px;
                                    margin-top: 0px;
                                `,
                            ],
                            "max",
                        )}
                }

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 75%;
                            `,
                            css`
                                width: 68%;
                            `,
                            css`
                                width: 68%;
                            `,
                            css`
                                width: 80%;
                            `,
                        ],
                        "minMax",
                    )}
                > div[class^="Wrapper"] {
                    .category-section {
                        > div[class^="GridOffset"] {
                            > div:first-child[class^="GridItemStyle"] {
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(
                                        theme,
                                        [
                                            null,
                                            null,
                                            css`
                                                flex-basis: 30%;
                                                max-width: 30%;
                                            `,
                                            null,
                                        ],
                                        "minMax",
                                    )}
                            }
                            > div:last-child[class^="GridItemStyle"] {
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(theme, [null, null, null, null], "minMax")}
                                > div[class^="Wrapper"] {
                                    > div[class^="ContentWrapper"] {
                                        padding: 9px 0 0;
                                        ${({ theme }: { theme: BaseTheme }) =>
                                            breakpointMediaQueries(
                                                theme,
                                                [
                                                    null,
                                                    null,
                                                    css`
                                                        padding: 11px 0 0;
                                                    `,
                                                    null,
                                                ],
                                                "minMax",
                                            )}
                                        .GenericCategory {
                                            font-weight: 600;
                                            > a[class^="StyledButton"] {
                                                > span[class^="TypographyStyle"] {
                                                    color: #ffffff;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            > div:first-child {
                flex-grow: 1;
            }
            > div:last-child {
                display: flex;
                align-items: center;
                justify-content: center;
                height: auto;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                max-width: 22%;
                                display: flex;
                                margin-left: auto;
                            `,
                            css`
                                max-width: 22%;
                                display: flex;
                                margin-left: auto;
                            `,
                            css`
                                max-width: 22%;
                                display: flex;
                                margin-left: auto;
                            `,
                        ],
                        "minMax",
                    )}
                > div:first-child {
                    > button[data-test-selector="header_shipToButton"] {
                        display: none;
                    }
                }
                > div {
                    &:nth-child(2) {
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    null,
                                    null,
                                    css`
                                        display: none;
                                    `,
                                    null,
                                ],
                                "minMax",
                            )}
                        > nav {
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(
                                    theme,
                                    [
                                        css`
                                            display: none;
                                        `,
                                        css`
                                            display: none;
                                        `,
                                        null,
                                        null,
                                    ],
                                    "minMax",
                                )}
                            > span[class^="StyledButton"] {
                                color: rgb(255, 255, 255);
                                font-weight: 600;
                                > span[class^="IconWrapper"] {
                                    color: rgb(255, 255, 255);
                                }
                            }
                        }
                    }
                }
                > div[id^="loginWrapper"] {
                    > button[class^="StyledButton"] {
                        color: rgb(255, 255, 255);
                        font-weight: 600;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        display: none;
                                    `,
                                    css`
                                        display: none;
                                    `,
                                    css`
                                        display: none;
                                    `,
                                    null,
                                ],
                                "minMax",
                            )}
                        > span[class^="IconWrapper"] {
                            color: rgb(255, 255, 255);
                        }
                        > span[class^="TypographyStyle"] {
                            font-weight: 600;
                        }
                    }
                }
            }
        `,
    },
    websiteName: {
        css: css`
            @media print {
                display: block;
            }
            font-size: 12px;
            padding-left: 15px;
            display: none;
        `,
    },
    Scroll: {
        css: css`
            display: none;
        `,
    },
    ScrollFixed: {
        css: css`
            &.mainContainer {
                position: fixed;
                width: 100%;
                z-index: 999;
                > div {
                    padding: 0px 15px;
                    > div:last-child[class^="Wrapper"] {
                        width: 50%;
                        > div {
                            > button[class^="StyledButton"] {
                                color: rgb(255, 255, 255);
                                font-weight: 600;
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(
                                        theme,
                                        [
                                            css`
                                                display: none;
                                            `,
                                            css`
                                                display: none;
                                            `,
                                            null,
                                            null,
                                        ],
                                        "minMax",
                                    )}
                                > span[class^="IconWrapper"] {
                                    color: rgb(255, 255, 255);
                                }
                                > span[class^="TypographyStyle"] {
                                    font-weight: 600;
                                }
                            }
                            button[data-test-selector="headerSignOutLink"] {
                                color: rgb(255, 255, 255);
                                font-weight: 600;
                                margin-right: 20px;
                            }
                            > nav {
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(
                                        theme,
                                        [
                                            css`
                                                display: none;
                                            `,
                                            css`
                                                display: none;
                                            `,
                                            null,
                                            null,
                                        ],
                                        "minMax",
                                    )}
                                > span[class^="StyledButton"] {
                                    color: rgb(255, 255, 255);
                                    font-weight: 600;
                                    > span[class^="IconWrapper"] {
                                        color: rgb(255, 255, 255);
                                    }
                                }
                            }
                        }
                        > div:last-child[class^="sc"] {
                            > a[class^="StyledButton"] {
                                > span[class^="IconWrapper"] {
                                    margin-left: 12px;
                                }
                            }
                        }
                    }
                }
            }
            .stickyLogoStyle {
                width: 15%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    )}
                > div[class^="Wrapper"] {
                    > div {
                        > a[class^="StyledButton"] {
                            > span[class^="TypographyStyle"] {
                                > div[class^="LazyImageStyle"] {
                                    > img {
                                        height: 45px;
                                        width: auto;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .mainNavigation {
                width: 57%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 75%;
                            `,
                            css`
                                width: 75%;
                            `,
                            null,
                            css`
                                width: 32%;
                            `,
                        ],
                        "minMax",
                    )}
                > div[class^="Wrapper"] {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    padding-top: 0;
                                `,
                                css`
                                    padding-top: 0;
                                `,
                                null,
                                null,
                            ],
                            "minMax",
                        )}
                    > div[id^="mobile_wrapper"] {
                        > div[class^="HiddenStyle"] {
                            > button[class^="ButtonWrapper"] {
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(
                                        theme,
                                        [
                                            css`
                                                background: rgb(168, 16, 16) !important;
                                                border: 2px solid rgb(168, 16, 16) !important;
                                            `,
                                            css`
                                                background: rgb(168, 16, 16) !important;
                                                border: 2px solid rgb(168, 16, 16) !important;
                                            `,
                                            null,
                                            null,
                                        ],
                                        "minMax",
                                    )}
                            }
                        }
                    }
                    .category-section {
                        > div[class^="GridOffset"] {
                            > div:first-child[class^="GridItemStyle"] {
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(
                                        theme,
                                        [
                                            null,
                                            null,
                                            null,
                                            css`
                                                flex-basis: 100%;
                                                max-width: 100%;
                                            `,
                                        ],
                                        "minMax",
                                    )}
                            }
                            > div:last-child[class^="GridItemStyle"] {
                                ${({ theme }: { theme: BaseTheme }) =>
                                    breakpointMediaQueries(theme, [null, null, null, null], "minMax")}
                                > div[class^="Wrapper"] {
                                    > div[class^="ContentWrapper"] {
                                        padding: 10px 0 0;
                                        .GenericCategory {
                                            font-weight: 600;
                                            > a[class^="StyledButton"] {
                                                > span[class^="TypographyStyle"] {
                                                    color: #ffffff;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .searchStyle {
                width: 50%;
                display: flex;
                -webkit-box-pack: center;
                justify-content: center;
                -webkit-box-align: center;
                align-items: center;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                display: none;
                            `,
                            css`
                                display: none;
                            `,
                            null,
                            null,
                        ],
                        "minMax",
                    )}
                div[class^="OverflowWrapper"] {
                    width: 100% !important;
                }
                [class^="FormFieldStyle"] {
                    width: 100%;
                    [class^="FormInputWrapper"] {
                        input {
                            height: 30px !important;
                            background: rgb(241, 241, 241);
                            border-color: #000;
                            border: 1px solid rgb(204, 204, 204);
                        }
                        > button[class^="StyledButton"] {
                            > span[class^="IconWrapper"] {
                                height: 28px !important;
                                color: #555555;
                            }
                        }
                    }
                }
                input[type="text"] {
                    & + button {
                        background: rgb(204, 204, 204);
                        height: 30px !important;
                        color: #555555;
                    }
                }
            }
        `,
    },
};

const styles = headerStyles;

const Header = ({ id, siteName, session, toaster, history, myAccountPageUrl, dismissRfqUpdates }: Props) => {
    const [offset, setOffset] = useState(0);
    const viewMyDashboardClickHandler = () => {
        if (myAccountPageUrl) {
            history.push(myAccountPageUrl);
        }
    };

    useEffect(() => {
        if (session.hasRfqUpdates && session.userRoles !== "PunchOut" && myAccountPageUrl) {
            toaster.addToast({
                body: (
                    <>
                        <Typography>{translate("You have new quote information.")}</Typography>
                        <Link onClick={viewMyDashboardClickHandler}>{translate("View My Dashboard")}</Link>
                    </>
                ),
                messageType: "info",
                timeoutLength: 1000 * 60 * 60 * 24 * 365,
                onClose: () => {
                    dismissRfqUpdates();
                },
            });
        }
        if (session.properties?.hasMessageUpdate === "1" && session.userRoles !== "PunchOut") {
            toaster.addToast({
                body: (
                    <>
                        <Typography>{translate("You have a new Message.")}</Typography>
                        <Link onClick={viewMyDashboardClickHandler}>{translate("View My Dashboard")}</Link>
                    </>
                ),
                messageType: "info",
                timeoutLength: 1000 * 60 * 60 * 24 * 365,
                onClose: () => {
                    dismissRfqUpdates();
                },
            });
        }
    }, [myAccountPageUrl]);

    useEffect(() => {
        window.onscroll = () => {
            const check = window.parent.document.getElementById("siteIFrame");
            if (!check) {
                setOffset(window.pageYOffset);
            } else {
                setOffset(2000);
            }
        };
    }, []);

    const afterHeader = React.createRef<HTMLSpanElement>();
    return (
        <>
            <Page as="header" isHeader={true} {...styles.page}>
                <SkipNav
                    extendedStyles={styles.skipToContent}
                    text={translate("Skip to main content")}
                    destination={afterHeader}
                />
                <StyledWrapper
                    className="secondaryNavigation"
                    data-test-selector="secondaryNavigation"
                    {...(offset >= 123 ? { ...styles.Scroll } : "")}
                >
                    <Zone contentId={id} zoneName="SecondaryNavigation" />
                </StyledWrapper>
                <StyledWrapper className="mainContainer" {...(offset >= 123 ? { ...styles.ScrollFixed } : "")}>
                    <StyledWrapper {...styles.container}>
                        <StyledWrapper
                            className="stickyLogoStyle"
                            {...(offset >= 123 ? { ...styles.ScrollFixed } : { ...styles.Scroll })}
                        >
                            <Zone contentId={id} zoneName="stickyLogo" />
                        </StyledWrapper>
                        <StyledWrapper className="mainNavigation">
                            <Zone contentId={id} zoneName="MainNavigation" />
                        </StyledWrapper>
                        <StyledWrapper
                            className="searchStyle"
                            data-test-selector="searchNav"
                            {...(offset >= 123 ? { ...styles.ScrollFixed } : { ...styles.Scroll })}
                        >
                            <Zone contentId={id} zoneName="search" />
                        </StyledWrapper>
                        <Zone contentId={id} zoneName="Cart" />
                    </StyledWrapper>
                </StyledWrapper>
                <Zone contentId={id} zoneName="Breadcrumb" />
                <span ref={afterHeader} tabIndex={-1} />
            </Page>
        </>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withToaster(withHistory(Header))),
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export const HeaderContext = "HeaderContext";

export default pageModule;
